// 全局filter
/**
 *
 * 时间格式化
 * @export
 * @param { Date } date
 * @param { String } fmt
 * @return { String }
 */
export function dateFilter (date, fmt) {
  if (!date || date === '--') return '--'
  var d = new Date(date)
  var o = {
    'M+': d.getMonth() + 1, // 月份
    'd+': d.getDate(), // 日
    'h+': d.getHours(), // 小时
    'm+': d.getMinutes(), // 分
    's+': d.getSeconds(), // 秒
    'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
    S: d.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}
/**
 *
 * 返回时间的星期
 * @export
 * @param { Date } date
 * @return { String }
 */
export function weekFilter (date) {
  var week = ['日', '一', '二', '三', '四', '五', '六']
  if (typeof date === 'number') return week[date]
  var d = new Date(date)
  return week[d.getDay()]
}
/**
 *
 * 截取字符串的一部分用...表示
 * @export
 * @param { String } str
 * @param { Number } number
 * @return { String }
 */
export function strCut (str, number, cut) {
  if (typeof str !== 'string') return null
  const long = str.length
  if (long < number) {
    return str
  } else {
    return str.substr(0, number) + (cut || '...')
  }
}

/**
 *
 * 增加单位
 * @export
 * @param { String, Number } val
 * @param { String } unit
 * @return { String }
 */
export function unit (val, unit) {
  if (val === '--') return '--'
  if (val === 0 || val) {
    return val + unit
  } else {
    return '--'
  }
}

/**
 *
 * 空值（'' | null | undefined）处理
 * @export
 * @param { String } val
 * @return { String }
 */
export function nullFilter (val) {
  return (val === 0 || val) ? val : '--'
}

/**
 *
 * 截取数组
 * @export
 * @param {*} arr
 * @param {*} length
 * @return {*}
 */
export function arrayCut (arr, length) {
  if (arr) {
    if (typeof arr === 'string') {
      arr = arr.replace('[', '').replace(']', '').split(',')
    }
    const l = length > arr.length ? arr.length : length
    const a = arr.filter((o, index) => {
      if (index < l) {
        return o
      }
    })
    return a
  } else {
    return '--'
  }
}

/**
 *
 * 对象处理，数组时传入index
 * @export
 * @param {*} obj
 * @param {*} arg
 */
export function objValue (obj, arg, index) {
  if (obj) {
    let result
    if (typeof arg === 'string') {
      result = obj[arg]
    } else if (Array.isArray(arg)) {
      result = obj
      for (let i = 0; i < arg.length; i++) {
        result = result[arg[i]]
      }
    }
    if (Array.isArray(result)) {
      return result[index]
    } else {
      return nullFilter(result)
    }
  } else {
    return '--'
  }
}
// 过滤处理负数
export function objVal (value) {
  if (value < 0) {
    return 'N/A'
  } else if (value >= 0) {
    return value
  }
}

// 负数单位处理并保留小数
export function keepTwoDecimal (value, v) {
  if (value < 0) {
    return 'N/A '
  } else if (value >= 0) {
    var result = parseFloat(value)
    if (isNaN(result)) {
      return false
    }
    result = Math.round(value * 100) / 100
    return result + v
  }
}

// 负数显示处理
export function strVal (obj) {
  if (!obj && Number(obj) !== 0) {
    return '--'
  } else if (typeof obj === 'number') {
    return obj < 0 ? 'N/A' : obj
  }
}
/* 本项目专用 filter */

// 电站状态
export function statusFilter (val) {
  if (!val) return '--'
  if (val === '0') {
    return '在线'
  } else if (val === '1') {
    return '部分在线'
  } else if (val === '2') {
    return '离线'
  } else if (val === '3') {
    return '报警'
  }
}
// 电表状态
export function meterFilter (type) {
  if (type === '0') {
    return '正常'
  } else if (type === '1') {
    return '离线'
  }
}
// 设备状态
export function statusDFilter (val) {
  if (!val) return '--'
  if (val === '0') {
    return '在线'
  } else if (val === '1') {
    return '离线'
  } else if (val === '2') {
    return '报警'
  }
}
// 设备类型
export function gtypeFilter (val) {
  if (!val) return '--'
  if (val === '0') {
    return '组串'
  } else if (val === '1') {
    return '储能'
  } else if (val === '2') {
    return '气象'
  } else if (val === '3') {
    return '电表'
  }
}

// 通讯类型
export function netFilter (val) {
  if (!val) return '--'
  if (val === '0') {
    return 'WIFI'
  } else if (val === '1') {
    return '2G'
  } else if (val === '2') {
    return '3G'
  } else if (val === '3') {
    return '4G'
  }
}

// 通道
export function pvFilter (val, pv) {
  if (val > pv) {
    return '--'
  } else {
    return 'PV' + val
  }
}

// 相位
export function lFilter (val) {
  if (val > 3) {
    return '--'
  } else {
    return 'L' + val
  }
}
export function Decimal (value) {
  var result = parseFloat(value)
  if (isNaN(result)) {
    return false
  }
  result = Math.round(value * 1000) / 1000
  return result
}
